import { NgSwitch, NgSwitchCase, NgSwitchDefault } from "@angular/common";
import { Component, HostBinding, Input } from "@angular/core";
import { NbCardModule, NbIconModule, NbUserModule } from "@nebular/theme";

@Component({
  standalone: true,
  selector: "ngx-placeholder",
  styleUrls: ["placeholder.component.scss"],
  templateUrl: "placeholder.component.html",
  imports: [
    NbCardModule,
    NbIconModule,
    NbUserModule,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
  ],
})
export class PlaceholderComponent {
  @Input() type?: string;
  @Input() bg?: string = "light";

  @HostBinding("attr.aria-label")
  label = "Loading";
}
